import PanelHead from "../../UI/Panel/PanelHead";
import PanelBody from "../../UI/Panel/PanelBody";
import { ResellersTable } from "../../UI/Resellers/ResellersTable";

const Resellers = () => {
  return (
    <div>
      <PanelHead title="Resellers" />
      <PanelBody content={<ResellersTable />} />
    </div>
  );
};

export default Resellers;
